import { ChartData } from './ChartData';
import { ChartDataComparisonType } from './ChartDataComparisonType';
import { ChartDataType } from './ChartDataType';

export class ChartDataArray {
  public containsCurrency = false;

  public isCurrencyBreakdown = false;

  public color?: string;

  public dashed?: boolean = false;

  public get isComparison() {
    return this.comparisonType === ChartDataComparisonType.comparison;
  }

  public get isSecondary() {
    return this.type === ChartDataType.secondary;
  }

  public get isPlan() {
    return this.comparisonType === ChartDataComparisonType.plan;
  }

  constructor(
    public type: ChartDataType,
    public label: string,
    public data: ChartData[],
    public comparisonType?: ChartDataComparisonType,
    public isOther?: boolean
  ) {}

  public getData(limit?: number, inverted?: boolean): ChartData[] {
    if (!!limit || limit === 0) {
      return inverted ? this.data.slice(this.data.length - limit) : this.data.slice(0, limit);
    }
    return this.data;
  }
}
